import React, { useState, useEffect, useCallback, useMemo } from "react" // eslint-disable-line
import { useGeneral } from "../../../context/general"
import axios from "axios"

export default function useEarnings() {
    const [earnings, setEarnings] = useState({})
    const [lastDataDate, setLastDataDate] = useState(new Date())
    const { watchlistProjects } = useGeneral()

    const formatDate = (date) => date.toLocaleDateString('en-CA')

    const getStartingRange = useCallback(() => { // getting first range of three months ahead
        const today = new Date()
        today.setDate(1)
        const endDate = new Date()
        endDate.setMonth(endDate.getMonth()+3)

        return [formatDate(today), formatDate(endDate)]
    }, [])

    const getEarnings = (startDate, endDate) => {
        // fetch('/api/getEarnings', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({from: startDate, to: endDate})
        // })
        axios({
            method: 'POST',
            url: '/api/getEarnings',
            data: {from: startDate, to: endDate}
        })
        .then(res => res.data)
        .then(res => res.status === 200 && setEarnings((state) =>  ({...state, ...res.data})))
    }

    const watchListEarnings = useMemo(() => {
        const watchListTickers = watchlistProjects?.map(project => project.ticker)
        const updatedWatchListCompanies = {}
        Object.entries(earnings).forEach(([date, companies]) => companies?.length && companies.forEach(company => {
            if (watchListTickers?.includes(company.symbol)) updatedWatchListCompanies[date] = [company]
        }))

        return updatedWatchListCompanies
    }, [earnings, watchlistProjects])

    const getLastThreeMonthsEarnings = (date) => { // argument in Date format. 
        const startDate = new Date()
        startDate.setMonth(date.getMonth()-3)

        getEarnings(formatDate(startDate), formatDate(date))
    }

    const ifNeedUpdateEarnings = (date) => {
        if (date < lastDataDate){
            getLastThreeMonthsEarnings(lastDataDate)

            const newDate = lastDataDate
            newDate.setMonth(lastDataDate.getMonth() - 3)
            setLastDataDate(newDate)
        }
    }

    useEffect(() => {
        const [startDate, endDate] = getStartingRange()
        getEarnings(startDate, endDate)
        return () => {}
    }, [getStartingRange])

    return {
        watchListEarnings,
        earnings,
        ifNeedUpdateEarnings,
        formatDate
    }
}